<template>
  <div class="special-container">
    <el-tabs class="tabs"
             v-model="activeName"
             @tab-click="handleClick">
      <el-tab-pane label="全部货源"
                   name="0"></el-tab-pane>
      <el-tab-pane label="待投标"
                   name="1"></el-tab-pane>
      <el-tab-pane label="进行中"
                   name="2"></el-tab-pane>
      <el-tab-pane label="招标完成"
                   name="3"></el-tab-pane>
      <el-tab-pane label="已失效"
                   name="4"></el-tab-pane>
    </el-tabs>
    <div class="special-search">
      <el-form :inline="true"
               :model="formInline"
               class="search-form-inline "
               label-position="right">
        <span class="imp">出发地</span>
        <el-cascader size="small"
                     class="addressStyle"
                     @active-item-change="handleItemChange"
                     :options="options"
                     v-model="addressFrom"
                     @change="handleChangeFrom">
        </el-cascader>
        <span class="imp">目的地</span>
        <el-cascader size="small"
                     class="addressStyle"
                     :options="options"
                     v-model="addressTo"
                     @active-item-change="handleItemChange"
                     @change="handleChangeTo">
        </el-cascader>
        <el-form-item label="原料"
                      class="material"
                      size="small">
          <el-input v-model="formInline.material"
                    placeholder="请输入原料名称"
                    class="material-name"></el-input>
        </el-form-item>
        <el-form-item class="itembtn"
                      size="small">
          <el-button class="search-submit"
                     type="primary"
                     @click="handleSearchClick">查询</el-button>
        </el-form-item>
        <el-form-item label="开始时间"
                      size="small">
          <el-date-picker v-model="startDate"
                          type="date"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          placeholder="选择开始时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间"
                      size="small">
          <el-date-picker v-model="endDate"
                          type="date"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          placeholder="选择结束时间">
          </el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <div class="container">
      <el-table :data="data.result"
                style="width: 100%"
                class="table_main"
                height="100%">
        <el-table-column class-name="number"
                         label="序号"
                         align="center"
                         type="index"
                         min-width="40">
        </el-table-column>
        <el-table-column class-name="sourceNumber"
                         prop="goodsNo"
                         label="货源编号">
        </el-table-column>
        <el-table-column label="货主信息">
          <template slot-scope="scope">
            <div><span>公司名称：</span>{{scope.row.companyName}}</div>
            <div><span>联系人姓名：</span>{{scope.row.companyLinkman}}</div>
            <div><span>联系电话：</span>{{scope.row.companyPhone}}</div>
          </template>
        </el-table-column>
        <el-table-column label="位置信息">
          <template slot-scope="scope">
            <div><span>出发地：</span>{{scope.row.departureName}}{{scope.row.departureAddress}}</div>
            <div><span>目的地：</span>{{scope.row.destinationName}}{{scope.row.destinationAddress}}</div>
          </template>
        </el-table-column>
        <el-table-column label="货源信息">
          <template slot-scope="scope"
                    class="sourceInfo">
            <div><span>炼厂名称：</span>{{scope.row.factoryName}}</div>
            <div><span>原料：</span>{{scope.row.material}}</div>
            <div><span>重量：</span>{{scope.row.totalWeight}}吨</div>
            <div v-if="scope.row.tankBody==='0'"><span>罐体：</span>铝罐</div>
            <div v-if="scope.row.tankBody==='1'"><span>罐体：</span>铁罐</div>
            <div v-if="scope.row.tankBody==='2'"><span>罐体：</span>钢罐</div>
            <div v-if="scope.row.tankBody==='3'"><span>罐体：</span>铝合金</div>
            <div v-if="scope.row.tankBody==='4'"><span>罐体：</span>不限</div>
            <div><span>货源有效期：</span>{{scope.row.startTime}}至{{scope.row.endTime}}</div>
          </template>
        </el-table-column>
        <el-table-column label="招标详情">
          <template slot-scope="scope">
            <div><span>已匹配重量：</span><span>{{scope.row.matchWeight}}</span>吨</div>
            <div><span>已匹配公司：</span>{{scope.row.matchVehicle}}个</div>
            <div><span>已谈成重量：</span>{{scope.row.talkWeight}}吨</div>
            <div><span>已谈成公司：</span>{{scope.row.talkVehicle}}个</div>
          </template>
        </el-table-column>
        <el-table-column label="状态"
                         header-align="center"
                         align="center"
                         width="67">
          <template slot-scope="scope">
            <div v-if="scope.row.goodsState==='0'"
                 class="status-style wait">待投标</div>
            <div v-else-if="scope.row.goodsState==='1'"
                 class="status-style progress">进行中</div>
            <div v-else-if="scope.row.goodsState==='2'"
                 class="status-style pass"><span>投标</span> <span>完成</span></div>
            <div v-else-if="scope.row.goodsState==='3'"
                 class="status-style failure">已失效</div>
          </template>
        </el-table-column>
        <el-table-column header-align="center"
                         label="操作"
                         width="150"
                         align="center">
          <template slot-scope="scope">
            <el-button v-if="scope.row.goodsState !=='0'"
                       class="btnc"
                       @click="handleBiddingDetailClick(scope.row.id)">
              投标详情
            </el-button>
          </template>

        </el-table-column>

      </el-table>
      <el-dialog title="投标详情"
                 :visible.sync="biddingDetail"
                 class="biddingTable">
        <el-table ref="multipleTable"
                  :data="detailData"
                  tooltip-effect="dark"
                  style="width: 100%"
                  :row-key="getRowKeys"
                  :expand-row-keys="expands"
                  max-height="491">

          <el-table-column label="报价编号"
                           align="left"
                           min-width="80">
            <template slot-scope="scope">{{scope.row.truckBidNo}}</template>
          </el-table-column>
          <el-table-column label="物流公司"
                           align="left">
            <template slot-scope="scope">
              <div><span>公司名称：</span><span>{{scope.row.companyName}}</span></div>
              <div><span>联系人姓名：</span><span>{{scope.row.logisticslinkMan}}</span></div>
              <div><span>联系电话：</span><span>{{scope.row.companyPhone}}</span></div>
            </template>
          </el-table-column>
          <el-table-column label="报价信息"
                           align="left">
            <template slot-scope="scope">
              <div><span>运费报价：</span><span>{{scope.row.freightQuotation}}元/吨</span></div>
              <div><span>车辆总数：</span><span>{{scope.row.truckNo}}辆</span></div>
              <div><span>总荷载量：</span><span>{{scope.row.totalLoad}}吨</span></div>
              <div><span>装货时间：</span><span>{{scope.row.loadingTime}}</span></div>
            </template>
          </el-table-column>
          <el-table-column label="车辆信息"
                           align="left">
            <template slot-scope="scope">
              <div><span>已匹配重量：</span><span>{{scope.row.matchWeight}}</span>吨</div>
              <div><span>已匹配车辆：</span>{{scope.row.truckNo}}辆</div>
              <div><span>已谈成重量：</span>{{scope.row.talkWeight}}吨</div>
              <div><span>已谈成车辆：</span>{{scope.row.truckNo}}辆</div>
            </template>
          </el-table-column>
          <el-table-column label='招标状态'
                           align='center'>
            <template slot-scope="scope">
              <!-- <span v-if="scope.row.status === 0">投标失败</span> -->
              <span v-if="scope.row.status === 10|scope.row.status === 0">未谈成</span>
              <span v-else-if="scope.row.status === 20|scope.row.status === 21|scope.row.status === 22|scope.row.status === 23|scope.row.status === 24">已谈成</span>
            </template>
          </el-table-column>
          <el-table-column class-name="operation"
                           label="操作"
                           align="center"
                           width="100">
            <template slot-scope="scope">
              <el-button class="btnc"
                         v-if="scope.row.status===21|scope.row.status===22|scope.row.status===23|scope.row.status===24"
                         v-show="!scope.row.onoff"
                         @click="toggle(scope.row)">查看车辆</el-button>
              <el-button class="btnc"
                         v-if="scope.row.status===21|scope.row.status===22|scope.row.status===23|scope.row.status===24"
                         v-show="scope.row.onoff"
                         @click="toggle(scope.row)">收起</el-button>

              <p v-else-if="scope.row.status===10">
                暂未匹配车辆
              </p>
              <p v-else-if="scope.row.status===20">
                暂未匹配车辆
              </p>
            </template>
          </el-table-column>
          <el-table-column label=""
                           type="expand"
                           width="1">
            <template slot-scope="scope">
              <el-table style="width: 674px"
                        :data="scope.row.carDetail.result"
                        max-height="400">
                <el-table-column label="物流公司"
                                 width="180">
                  <template slot-scope="props">
                    <div>
                      <span>公司名称：</span>
                      <span>{{props.row.companyName}}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="车辆信息"
                                 width="180">
                  <template slot-scope="props">
                    <div>
                      <span>车头号：</span>
                      <span>{{props.row.truckHeadNo}}</span>
                    </div>
                    <div>
                      <span>车挂号：</span>
                      <span>{{props.row.truckEndNo}}挂</span>
                    </div>
                    <div>
                      <span>罐体：</span>
                      <span v-if="props.row.tankType === '01'">钢罐</span>
                      <span v-else-if="props.row.tankType === '02'">铁罐</span>
                      <span v-else-if="props.row.tankType === '03'">白钢罐</span>
                      <span v-else-if="props.row.tankType === '04'">铝合金罐</span>
                    </div>
                    <div>
                      <span>核载量：</span>
                      <span>{{props.row.loadCapacity}}吨</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="司机信息">
                  <template slot-scope="props">
                    <div>
                      <span>姓名：</span>
                      <span>{{props.row.driverName}}</span>
                    </div>
                    <div>
                      <span>手机号：</span>
                      <span>{{props.row.driverPhone}}</span>
                    </div>
                    <div>
                      <span>身份证号：</span>
                      <span>{{props.row.driverIdcardNo}}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="车辆状态"
                                 align="center"
                                 class-name="carStatus">
                  <template slot-scope="props">
                    <span v-if="props.row.status === 1">待运输</span>
                    <span v-else-if="props.row.status === 2">运输中</span>
                    <span v-else-if="props.row.status === 3"
                          class="complate">运输完成</span>
                  </template>

                </el-table-column>
              </el-table>
            </template>

          </el-table-column>
        </el-table>
      </el-dialog>
    </div>
    <!-- 分页 -->
    <div class="pages">
      <span class="demonstartion"> 共{{data.total}}条记录</span>
      <el-pagination @current-change="handleCurrentChange"
                     :page-size="data.pageSize"
                     layout="prev, pager, next"
                     :total="data.total"
                     background>
      </el-pagination>

    </div>
  </div>
</template>

<script>
import {
  privatelist,
  privateDetail,
  privateCarDetail,
  provinceList,
  cityList,
  areaList
} from 'apis/index'
export default {
  name: 'Container',
  data () {
    return {
      activeName: '0',
      options: [],
      addressFrom: [],
      addressTo: [],
      from: '',
      to: '',
      address: '',
      biddingDetail: false,
      formInline: {
        material: '',
        from: '',
        to: ''
      },
      data: {},
      carDetail: {},
      startDate: '',
      endDate: '',
      detailData: [],
      getRowKeys (row) {
        return row.id
      },
      expands: []
    }
  },
  methods: {
    async initData () { // 省市区三级联动
      let ret = await provinceList()
      if (ret.data.code === 0) {
        let newData = JSON.stringify(ret.data.data.result)
        newData = newData.replace(/provinceCode/g, 'value')
        newData = newData.replace(/provinceName/g, 'label')
        this.options = JSON.parse(newData)
        this.options.forEach((item, index) => {
          this.$set(this.options[index], 'children', [])
        })
      }
    },
    async handleItemChange (val) {
      // console.log('active item:', val)
      // console.log(val)
      if (val.length === 1) { // 请求省，且只第一次才发请求
        let provinceCode = val[0]
        for (let j = 0; j < this.options.length; j++) {
          if (this.options[j].value === provinceCode && !this.options[j].children.length) {
            let ret = await cityList({ provinceCode })
            if (ret.data.code === 0) {
              let newData = JSON.stringify(ret.data.data.result)
              newData = newData.replace(/cityCode/g, 'value')
              newData = newData.replace(/cityName/g, 'label')
              let newCity = JSON.parse(newData)
              newCity.forEach(item => {
                item.children = []
              })
              this.$set(this.options[j], 'children', newCity)
              break
            }
          }
        }
      }
      if (val.length === 2) { // 请求市区，且只第一次才发请求
        let provinceCode = val[0]
        let cityCode = val[1]
        for (let j = 0; j < this.options.length; j++) {
          if (this.options[j].value === provinceCode && this.options[j].children.length) {
            for (let k = 0; k < this.options[j].children.length; k++) {
              if (this.options[j].children[k].value === cityCode && !this.options[j].children[k].children.length) {
                let ret = await areaList({ cityCode })
                if (ret.data.code === 0) {
                  if (!ret.data.data.result.length) { // 修复中山市/东莞市等三级为空数组的情况
                    let newArea = [{
                      value: this.options[j].children[k].value,
                      label: this.options[j].children[k].label
                    }]
                    this.$set(this.options[j].children[k], 'children', newArea)
                    break
                  }
                  let newData = JSON.stringify(ret.data.data.result)
                  newData = newData.replace(/areaCode/g, 'value')
                  newData = newData.replace(/areaName/g, 'label')
                  let newArea = JSON.parse(newData)
                  this.$set(this.options[j].children[k], 'children', newArea)
                  break
                }
              }
            }
          }
        }
      }
      // console.log('---', this.options)
    },
    getAddressText (value) { // 获取地址
      for (var i = 0; i < this.options.length; i++) {
        if (this.options[i].value === value[0]) {
          this.address = this.options[i].label
          let city = this.options[i].children
          for (var j = 0; j < city.length; j++) {
            if (city[j].value === value[1]) {
              this.address += ',' + city[j].label
              let area = city[j].children
              for (var k = 0; k < area.length; k++) {
                if (area[k].value === value[2]) {
                  this.address += ',' + area[k].label
                }
              }
            }
          }
        }
      }
    },
    handleChangeFrom (value) {
      this.getAddressText(value)
      this.from = this.address
      // console.log(this.from)
    },
    handleChangeTo (value) {
      this.getAddressText(value)
      this.to = this.address
      // console.log(this.to)
    },
    getData () { // 初始化获取数据
      privatelist().then(res => {
        if (res.data.code === 0) {
          this.data = res.data.data.result
        }
      })
    },
    handleClick (tab, event) { // table
      let goodsState = this.activeName === '0' ? '' : this.activeName - 1
      this.formInline = {
        material: ''
      }
      this.addressFrom = []
      this.addressTo = []
      this.startDate = ''
      this.endDate = ''

      // console.log(goodsState)
      privatelist({
        goodsState
      }).then(res => {
        if (res.data.code === 0) {
          this.data = res.data.data.result
        }
      })
    },
    handleBiddingDetailClick (id) { //  投标详情
      this.detailData = []
      privateDetail({
        id: id
      }).then(res => {
        if (res.data.code === 0) {
          console.log('aaaa', res)
          this.detailData = res.data.data.result
          this.biddingDetail = true
          this.detailData.forEach(element => {
            privateCarDetail({
              dedicatedOrderId: element.id,
              logisticsCompanyId: element.logisticsCompanyId
            }).then(res => {
              if (res.data.code === 0) {
                element.carDetail = res.data.data
                // console.log('aaa', element.carDetail)
                element.carDetail.result.forEach(details => {
                  details.companyName = element.carDetail.companyName
                })
                // console.log(element)
                element.onoff = false
              }
            })
          })
        }
      })
    },
    toggle (row) { // 投标详情展示下拉列表
      this.$refs.multipleTable.toggleRowExpansion(row)
      row.onoff = !row.onoff
      // console.log(row)
    },
    // getCarDetail (row) {
    //   console.log(row)
    //   privateCarDetail({
    //     dedicatedOrderId: row.id,
    //     logisticsCompanyId: row.logisticsCompanyId
    //   }).then(res => {
    //     if (res.data.code === 0) {
    //       this.carDetail = res.data.data
    //       console.log(res)
    //     }
    //   })
    // },
    handleSearchClick () { // 查询
      let goodsState = this.activeName === '0' ? '' : this.activeName - 1
      privatelist({
        goodsState: goodsState,
        startTime: this.startDate,
        endTime: this.endDate,
        departureName: this.from,
        destinationName: this.to,
        material: this.formInline.material
      }).then(res => {
        if (res.data.code === 0) {
          this.data = res.data.data.result
        }
      })
    },
    handleCurrentChange (val) { // 切页切换
      let pageNum = val
      let goodsState = this.activeName === '0' ? '' : this.activeName - 1
      // console.log(status)
      // console.log('sss', goodsState)
      privatelist({
        pageNum: pageNum,
        goodsState: goodsState,
        startTime: this.startDate,
        endTime: this.endDate,
        departureName: this.from,
        destinationName: this.to,
        material: this.formInline.material
      }).then(res => {
        this.data = res.data.data.result
      })
    }
  },
  mounted () {
    this.getData()
    this.initData()
  }
}
</script>
<style lang="stylus">
@import '~styles/varibles.styl'
@import '~styles/mixins.styl'
.special-container
  height 100%
  .tabs
    height 51px
    overflow hidden
    .el-tabs__nav-wrap::after
      height 1px
      bottom 1px
    .el-tabs__item
      padding 0
      text-align center
      height 51px
      line-height 50px
      width 92px
      size12()
      color #5e656f
    .el-tabs__item.is-active
      border-bottom 2px solid #409EFF
      color #1b88ee
    .el-tabs__active-bar
      background transparent !important
    .el-table th
      background #e7f0f8
  .special-search
    margin-top 4px
    padding 0 20px
    .el-table__header-wrapper, .el-form-item
      width 220px
      margin-bottom 10px
      margin-right 24px
      &:nth-last-child(1)
        margin-right 0
    .itembtn
      float right
      margin-right 0
      width auto
    .search-form-inline
      width 100%
      .company-name
        width 146px
        padding 0
        margin 0
      .el-input__inner
        width 146px
        height 28px
        size12()
      .imp
        display inline-block
        width 60px
        color #606266
        text-align right
      .addressStyle
        width 150px
        margin 0 20px 0 10px
        line-height 30px
      .search-submit
        padding 5px 20px
        background #fff
        text-align right
        color $bgColor
        size12()
        &:hover
          background $bgColor
          color #fff
    .el-date-editor.el-input, .el-date-editor.el-input__inner
      width 146px
      size12()
    .el-form--inline .el-form-item__label
      width 70px
      size12()
  .container
    margin-left 20px
    margin-right 20px
    height calc(100% - 200px)
    overflow hidden
    .table_main
      overflow-y hidden
      background #f7f9fb
    .el-table td div
      size12()
    .el-table th
      background #e7f0f8
      .cell
        text-align center
        size12()
    .status-style
      width 40px
      height 40px
      border-radius 50%
      margin 0 auto
      border 1px solid transparent
      size10()
      line-height 40px
      text-align center
    .wait
      background #ffffff
      color #1B88EE
      border 1px solid #CFD5DC
    .progress
      progress()
    .pass
      background #00D5B9
      color #fff
      padding-top 5px
      span
        display block
        width 40px
        height 15px
        line-height 15px
    .failure
      failure()
    .el-button
      size12()
      margin-top 10px
    .btnc
      btnc()
    .biddingTable
      .el-dialog
        width auto
        max-width 728px
        .el-dialog__header
          height 42px
          padding 0 20px 0
          background #1b88ee
          .el-dialog__title
            line-height 42px
            font-size 13px
            color #fff
            float left
          .el-dialog__headerbtn
            top 12px
            right 12px
            .el-dialog__close
              color #fff
              font-size 20px
        .el-dialog__body
          padding 15px 20px
          .colorBlue
            color #1b88ee
          .companySelect
            width 180px
            height 30px
            margin 0
            float left
            margin-bottom 20px
            .el-input__inner
              width 145px
              height 30px
            .el-input-group__append
              padding 0
              .el-button
                margin 0
              .el-button--mini, .el-button--mini.is-round
                padding 7px 12px
          .operation
            .el-button
              margin 0
              padding 7px 14px
          .operations
            .el-button
              margin-bottom 0
              padding 7px 27px
          .el-table__expanded-cell
            padding 0
            th
              background #F7F8FB
            td
              background #F7F8FB
              .carStatus
                .cell
                  color #f66 !important
                span
                  color #f66 !important
  .pages
    margin-top 15px
    margin-bottom 15px
    .demonstartion
      float right
      line-height 45px
      color #5e656f
  .el-table td, .el-table th
    vertical-align top
</style>
